import { useGet, usePost } from '@/api/lib/integration';
import type { Handlung, LogHandlung, SubmitHandlung } from '@/api/handlungen/types';

export const getHandlungen = useGet<void, Handlung[]>('/api/handlungen');

export const logHandlung = usePost<LogHandlung, void>('/api/handlungen/{handlungId}/log');

export const closeHandlung = usePost<{ handlungId: number }, void>('/api/handlungen/{handlungId}/close');

export const submitHandlung = usePost<SubmitHandlung, Handlung>('/api/handlungen/{handlungId}/submit');
